module.exports = __webpack_public_path__ + "static/media/am.1f8cb3f4.svg";